import { useQuery } from '@tanstack/react-query';
import { IGetBatchDetailsResponse } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetBatchById = (id?: string) =>
  useQuery({
    queryKey: ["get_batch_by_id", id],
    queryFn: async (): Promise<IGetBatchDetailsResponse> => {
      const res = await apiClient.get(ENDPOINTS.BATCHES.GET_BATCH_BY_ID(id!));
      return res.data;
    },
    enabled: !!id,
  });
